export default __webpack_public_path__ + "static/media/B52_2.582eece9.webp";